import Box from "@mui/material/Box";
import axios from "axios";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as c from '../../../../constants.jsx';
import SubLine from "../../../../components/TextComps/SubLine.jsx";
import ButtonsMain from "../../../../components/Button/ButtonMain.jsx";
import { useTheme } from "@mui/material";



export default function UpgradeDetails() {

  const theme = useTheme();

  const url_billing_info = `${c.API_URL}/api/retrieve-billing-info/` 
   const url_update_subscription = `${c.API_URL}/api/update-subscription/` 

  const [billingInfo, setBillingInfo] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  
  React.useEffect(() => {
    retrieveBillingInfo();
  }, []);

    const retrieveBillingInfo = () => {
    axios.get(url_billing_info)
      .then((res) => {
        setBillingInfo(res.data);
      })
      .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          setError(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          setError("The request was made but no response was received.");
        } else {
          // Something happened in setting up the request that triggered an Error
          setError("Error: " + error.message);
        }
      });
  };

  // Handle form submission.
  const handleUpdateSubscription = async (event, selectedProductId) => {
    event.preventDefault();
    setLoading(true);
    const res = await updateSubscription(selectedProductId);
    if (res) {
      navigate("/SubscriptionWelcome", {
        state: { successfullyUpdatedPlan: true },
      });
    }
    setLoading(false);
  };

  const updateSubscription = async (selectedProductId) => {
    return await axios.post(url_update_subscription, {
        selected_product_id: selectedProductId,
      })
      .then((res) => {
        return res;
      })
      .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          setError(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          setError("The request was made but no response was received.");
        } else {
          // Something happened in setting up the request that triggered an Error
          setError("Error: " + error.message);
        }
      });
  };

const selectedProductId = "3"

  return (
<>

{theme.palette.mode === "light" ? (
    
<Box sx={{p:2, bgcolor: 'grey.C100', borderRadius: '10px'}}>
        
{billingInfo && billingInfo.all_product_choices.length > 0 && billingInfo.all_product_choices.map((plan) => ( plan.id === 3 &&
  <>
      <SubLine topic = "Plan Name:" value = {plan.name} /> 
      <SubLine topic = "Plan Price:" value = {plan.prices[0].price} />
      <SubLine topic = "Plan Description:" value = {plan.descriptions[0].description} />

      <Box sx={{mt:4, mb:2, display: 'flex', justifyContent: 'center'}}>
        <ButtonsMain name = "Upgrade" action = {(e) => {handleUpdateSubscription(e, selectedProductId) }}  />
      </Box>
  </>  
  
    ))} 

</Box> 

) : (

  <Box sx={{p:2, bgcolor: 'secondary.C700', borderRadius: '10px'}}>
        
        {billingInfo && billingInfo.all_product_choices.length > 0 && billingInfo.all_product_choices.map((plan) => ( plan.id === 3 &&
          <>
              <SubLine topic = "Plan Name:" value = {plan.name} /> 
              <SubLine topic = "Plan Price:" value = {plan.prices[0].price} />
              <SubLine topic = "Plan Description:" value = {plan.descriptions[0].description} />
        
              <Box sx={{mt:4, mb:2, display: 'flex', justifyContent: 'center'}}>
                <ButtonsMain name = "Upgrade" action = {(e) => {handleUpdateSubscription(e, selectedProductId) }}  />
              </Box>
          </>  
          
            ))} 
        
  </Box>

)}

</>
)}

